<template>
    <div
        v-if="amountOfOptions === 2"
        class="flex gap-8 border border-primary-20 rounded-32 p-8 w-fit"
    >
        <label
            v-for="(option, index) in options"
            :key="id + (id ? '-' : '') + 'option-' + (index + 1)"
            :for="id + (id ? '-' : '') + 'option-' + (index + 1)"
            :class="[option.disabled ? 'cursor-pointer' : 'cursor-not-allowed', option.classes ? option.classes : selectedOption.value === option.value ? 'bg-secondary text-neutral-white' : 'text-neutral-black']"
            class="px-16 py-8 font-semibold rounded-32 cursor-pointer select-none"
        >
            <input
                type="radio"
                :id="id + (id ? '-' : '') + 'option-' + (index + 1)"
                :name="id"
                :checked="selectedOption.value === option.value"
                class="hidden"
                :disabled="option.disabled"
                @click="$emit('input', option.value)"
            >
            <span :class="{'first-letter:uppercase': capitalize}">
                {{ option.label }}
            </span>
        </label>
    </div>
    <div
        v-else
        class="flex"
    >
        <label
            v-for="(option, index) in options"
            :key="id + (id ? '-' : '') + 'option-' + (index + 1)"
            :for="id + (id ? '-' : '') + 'option-' + (index + 1)"
            :class="[option.disabled ? 'cursor-not-allowed' : 'cursor-pointer', index === 0 ? 'rounded-l-32 border-r-0' : index === amountOfOptions - 1 ? 'rounded-r-32' : 'border-r-0', option.classes ? option.classes : selectedOption.value === option.value ? 'bg-secondary text-neutral-white' : 'text-neutral-black']"
            class="border border-primary-20 py-8 px-16 font-semibold flex items-center gap-4 select-none"
        >
            <input
                type="radio"
                :id="id + (id ? '-' : '') + 'option-' + (index + 1)"
                :name="id"
                :checked="selectedOption.value === option.value"
                class="hidden"
                :disabled="option.disabled"
                @click="$emit('input', option.value)"
            >
            <svg-icon
                :type="selectedOption.value === option.value ? 'radio-button-checked' : 'radio-button-unchecked'"
                class="w-18 h-18"
            />
            <span :class="{'first-letter:uppercase': capitalize}">
                {{ option.label }}
            </span>
        </label>
    </div>
</template>
<script>
import SvgIcon from './SvgIcon.vue';
export default {
    name: "SegmentedButton",
    components: {
        SvgIcon,
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        value: {
            type: [String, Number],
            required: true
        },
        disabled: Boolean,
        id: {
            type:String,
            required: true
        },
        capitalize: Boolean,
    },
    data() {
        return {
            toggleClasses: {
                default: 'border-neutral-black',
                checked: 'border-neutral-white bg-neutral-white ring-2 ring-secondary ring-inset',
                disabled: 'border-primary-60 bg-primary-60 ring-2 ring-secondary-20 ring-inset',
            }
        }
    },
    computed: {
        amountOfOptions() {
            return this.options.length;
        },
        selectedOption() {
            return this.options.find(option => option.value === this.value);
        },
        toggleClass() {
            return this.disabled ? this.toggleClasses.disabled : this.selectedOption ? this.toggleClasses.checked : this.toggleClasses.default;
        }
    },
}
</script>
<style scoped>
input[type='radio'] {
    &:checked {
        & ~ .toggle {
            @apply border-neutral-white bg-neutral-white ring-2 ring-secondary ring-inset;
        }
        &:disabled ~ .toggle {
            @apply border-primary-60 bg-primary-60 ring-2 ring-secondary-20 ring-inset;
        }
    }
    &:disabled ~ .toggle {
        @apply border-primary-60;
    }
    &:not(:checked):not(:disabled) {
        & ~ .toggle {
            @apply border-neutral-black;
        }
    }
}
</style>